module.exports = __webpack_public_path__ + "static/media/almofada1.619d8917.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/almofada1.png
// module id = 48
// module chunks = 0